const usersListReducer = ( state = {
	findUsers: null,
	isUsersListLoading: false,
    usersListFilteredStatus: null,
    usersListFilteredLicense: null,
	usersListFilteredRole: null,
	getAdministrators: null,
	selectedUserIds: [],
	isBulkUpdatingRole: false
}, action ) => {
	switch (action.type){
		case "FIND_USERS":
			state = {
				...state,
				findUsers: action.payload
			};
			break;
		case "USERS_LIST_LOADING":
			state = {
				...state,
				isUsersListLoading: action.payload
			};
			break;
		case "SELECTED_USER_IDS":
			state = {
				...state,
				selectedUserIds: action.payload
			};
			break;
		case "BULK_UPDATING_ROLE":
			state = {
				...state,
				isBulkUpdatingRole: action.payload
			};
			break;
		case "UPDATE_DEFAULT_USER_ROLE":
			state = {
				...state,
				findUsers: state.findUsers ? {
					...state.findUsers,
					defaultUserRole: action.payload
				} : state.findUsers
			};
			break;
        case "USERS_LIST_FILTERED_STATUS":
            state = {
                ...state,
                usersListFilteredStatus: action.payload
            };
            break;
        case "USERS_LIST_FILTERED_LICENSE":
            state = {
                ...state,
                usersListFilteredLicense: action.payload
            };
            break;
		case "USERS_LIST_FILTERED_ROLE":
			state = {
				...state,
				usersListFilteredRole: action.payload
			};
			break;
		case "GET_ADMINISTRATORS":
			state = {
				...state,
				getAdministrators: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default usersListReducer;
